import { render, staticRenderFns } from "./ServiceRecommendation.vue?vue&type=template&id=32a5befd&scoped=true"
import script from "./ServiceRecommendation.vue?vue&type=script&lang=js"
export * from "./ServiceRecommendation.vue?vue&type=script&lang=js"
import style0 from "./ServiceRecommendation.vue?vue&type=style&index=0&id=32a5befd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a5befd",
  null
  
)

export default component.exports